import { createSelector, createSlice, type PayloadAction } from '@reduxjs/toolkit'
import type { RootState } from '.'

type Token = {
  authToken: string | null
  address: string
  daoId: string
  exp: number
  iat: number
}

type SessionState = {
  lastChainId: string
  lastSafeAddress: { [chainId: string]: string }
  token: Token
}

const initialState: SessionState = {
  lastChainId: '',
  lastSafeAddress: {},
  token: {
    authToken: '',
    address: '',
    daoId: '',
    exp: 0,
    iat: 0,
  },
}

export const sessionSlice = createSlice({
  name: 'session',
  initialState,
  reducers: {
    setLastChainId: (state, action: PayloadAction<SessionState['lastChainId']>) => {
      state.lastChainId = action.payload
    },
    setLastSafeAddress: (
      state,
      action: PayloadAction<{
        chainId: string
        safeAddress: string
      }>,
    ) => {
      const { chainId, safeAddress } = action.payload
      state.lastSafeAddress[chainId] = safeAddress
    },
    setAuthToken: (state, action: PayloadAction<Token>) => {
      //need to decode token to get address, daoId, exp, iat
      state.token = { ...action.payload }
    },
  },
})

export const { setLastChainId, setLastSafeAddress, setAuthToken } = sessionSlice.actions

export const selectSession = (state: RootState): SessionState => {
  return state[sessionSlice.name]
}

export const selectLastSafeAddress = createSelector(
  [selectSession, (_, chainId: string) => chainId],
  (session, chainId): string | undefined => {
    return session.lastSafeAddress[chainId]
  },
)

export const selectAuthToken = (state: RootState) => state[sessionSlice.name].token?.authToken

export const selectTokenDetails = (state: RootState) => state[sessionSlice.name].token

export const selectTokenExp = (state: RootState) => state[sessionSlice.name].token.exp
